<template>
  <v-container id="container_completed">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <b>Vielen Dank für Ihre Anmeldung!</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-html="text" />
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    status: { type: String, default: '' }
  },

  mounted() {
    console.log(this.status)
  },

  computed: {
    text() {
      return this.status !== "Fehler"
        ? 'Ihre Anmeldung ist jetzt <b>abgeschlossen</b>. Sollten Sie noch Fragen haben können Sie uns gerne per Mail oder direkt telefonisch kontaktieren.'
        : 'Bei Ihrer Anmeldung ist etwas <b>schief gelaufen</b>. Die Validierung Ihrer Eingaben hat einen Fehler erzeugt. Bitte kontaktieren Sie unseren Verein direkt. Entschuldigen Sie die Unannehmlichkeiten.'
    }
  }
}
</script>

<style lang="scss">
#container_completed {
  width: 45%;
  margin-top: 5%
}
</style>